import(/* webpackMode: "eager" */ "/github/workspace/src/app/[locale]/not-found.tsx");
